import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { AppComponent } from './app.component';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { AppRoutingModule } from './/app-routing.module';
import { NavbarComponent } from './components/navbar/navbar.component';
import { HomeComponent } from './components/home/home.component';
import { SkillsGridComponent } from './components/skills/skills-grid.component';
import { MainService } from './services/main.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { MgrabPageComponent } from './pages/mgrab-page/mgrab-page.component';
import { MscanPageComponent } from './pages/mscan-page/mscan-page.component';
import { MturnPageComponent } from './pages/mturn-page/mturn-page.component';
import { SetexPageComponent } from './pages/setex-page/setex-page.component';
import { AlcampoPageComponent } from './pages/alcampo-page/alcampo-page.component';
import { WeareComponent } from './components/weare/weare.component';
import { QuoteComponent } from './components/quote/quote.component';
import { ValuesComponent } from './components/values/values.component';
import { ValuesGridComponent } from './components/values/values-grid/values-grid.component';
import { ValueDetailComponent } from './components/values/value-detail/value-detail.component';
import { FooterComponent } from './components/footer/footer.component';
import { ContactPageComponent } from './pages/contact-page/contact-page.component';
import { Skills2Component } from './components/skills2/skills2.component';
import { SkillsItemComponent } from './components/skills2/skills-item/skills-item.component';
import { SkillsCoverComponent } from './components/skills2/skills-cover/skills-cover.component';
import { SkillsDetailComponent } from './components/skills2/skills-detail/skills-detail.component';
import { FormsModule } from '@angular/forms';
import { FlexTemplatePageComponent } from './pages/flex-template-page/flex-template-page.component';
import { DespinassePageComponent } from './pages/despinasse-page/despinasse-page.component';
import { CsrComponent } from './components/csr/csr.component';
import { CsrPageComponent } from './pages/csr-page/csr-page.component';
import { McatalogPageComponent } from './pages/mcatalog-page/mcatalog-page.component';
import { MpayPageComponent } from './pages/mpay-page/mpay-page.component';
import { MhelpPageComponent } from './pages/mhelp-page/mhelp-page.component';
import { MbroadcastPageComponent } from './pages/mbroadcast-page/mbroadcast-page.component';
import { MecomPageComponent } from './pages/mecom-page/mecom-page.component';
import { McheckerPageComponent } from './pages/mchecker-page/mchecker-page.component';
import { MposPageComponent } from './pages/mpos-page/mpos-page.component';
import { MinventoryPageComponent } from './pages/minventory-page/minventory-page.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/');
}

@NgModule({
  declarations: [
    AppComponent,
    MainPageComponent,
    MgrabPageComponent,
    MscanPageComponent,
    MturnPageComponent,
    SetexPageComponent,
    AlcampoPageComponent,
    ContactPageComponent,
    NavbarComponent,
    SkillsGridComponent,
    HomeComponent,
    PortfolioComponent,
    WeareComponent,
    QuoteComponent,
    ValuesComponent,
    ValuesGridComponent,
    ValueDetailComponent,
    FooterComponent,
    Skills2Component,
    SkillsItemComponent,
    SkillsCoverComponent,
    SkillsDetailComponent,
    FlexTemplatePageComponent,
    DespinassePageComponent,
    CsrComponent,
    CsrPageComponent,
    McatalogPageComponent,
    MpayPageComponent,
    MhelpPageComponent,
    MbroadcastPageComponent,
    MecomPageComponent,
    McheckerPageComponent,
    MposPageComponent,
    MinventoryPageComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxPageScrollModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [MainService],
  bootstrap: [AppComponent]
})
export class AppModule { }
